//-- External Frameworks --------------------------------------------------------------------------
// React
import React from "react";
import * as AppRouting from "appRouting";
// Components
import Category_AgencyReports from "app/application/ui/sideBars/Category_AgencyReports";
import Category_OfficeReports from "app/application/ui/sideBars/Category_OfficeReports";
import Category_Products from "app/application/ui/sideBars/Category_Products";
import SideBar_Link from "app/application/ui/sideBars/SideBar_Link";
import SideBar_Category from "app/application/ui/sideBars/SideBar_Category";
import ContextSelector from "app/application/ui/sideBars/ContextSelector";
// Helpers
import NamingHelper from "common/utils/namingHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SideBar.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class SideBar extends React.Component {
    constructor(props) {
        super(props);
    }
    renderHomeOptions(officeId, agencyId, currentUrl) {
        if (officeId) {
            return (React.createElement(SideBar_Category, { text: NamingHelper.home, isExpanded: this.props.isExpanded, headingStyle: styles.linkStyleHome, headingIcon: "fa fa-home", url: AppRouting.officeUrl(officeId), currentUrl: currentUrl }));
        }
        else if (agencyId) {
            return (React.createElement(SideBar_Category, { text: NamingHelper.home, isExpanded: this.props.isExpanded, headingStyle: styles.linkStyleHome, headingIcon: "fa fa-home", url: AppRouting.agencyUrl(agencyId), currentUrl: currentUrl }));
        }
        else {
            return React.createElement("div", null);
        }
    }
    renderReportOptions(officeId, agencyId, currentUrl) {
        if (officeId) {
            return (React.createElement(Category_OfficeReports, { officeId: officeId, currentUrl: currentUrl, isExpanded: this.props.isExpanded }));
        }
        else if (agencyId) {
            return (React.createElement(Category_AgencyReports, { agencyId: agencyId, currentUrl: currentUrl, isExpanded: this.props.isExpanded }));
        }
        else {
            return React.createElement("div", null);
        }
    }
    render() {
        const { user, officeId, agencyId, onExpandClick } = this.props;
        const currentUrl = this.props.location.pathname;
        return (React.createElement("div", { className: styles.sideBar, onClick: () => { if (!this.props.isExpanded) {
                onExpandClick();
            } } },
            React.createElement(ContextSelector, { user: user, officeId: officeId, agencyId: agencyId, menuExpanded: this.props.isExpanded, hasSelection: this.props.hasSelection }),
            this.renderHomeOptions(officeId, agencyId, currentUrl),
            this.renderReportOptions(officeId, agencyId, currentUrl),
            React.createElement(Category_Products, { officeId: officeId, agencyId: agencyId, currentUrl: currentUrl, isExpanded: this.props.isExpanded }),
            React.createElement(SideBar_Category, { text: NamingHelper.settings, isExpanded: this.props.isExpanded, headingStyle: styles.linkStyleSettings, headingIcon: "fa fa-cog", url: AppRouting.settingsPath(), currentUrl: currentUrl },
                React.createElement(SideBar_Link, { text: NamingHelper.settingsMyProfile, url: AppRouting.profileUserPath() }),
                React.createElement(SideBar_Link, { text: NamingHelper.settingsContactUs, url: AppRouting.contactUsUrl(officeId) }))));
    }
}
export default SideBar;
